import React from 'react';

export const CollectionCardLazy = React.lazy(() => import('./CollectionCard'));
